import { render, staticRenderFns } from "./WithdrawCandidateDialog.vue?vue&type=template&id=754caeba&"
import script from "./WithdrawCandidateDialog.vue?vue&type=script&lang=js&"
export * from "./WithdrawCandidateDialog.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawCandidateDialog.vue?vue&type=style&index=0&id=754caeba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports